import { render, staticRenderFns } from "./CardFriend.vue?vue&type=template&id=6fa91248&scoped=true"
import script from "./CardFriend.vue?vue&type=script&lang=js"
export * from "./CardFriend.vue?vue&type=script&lang=js"
import style0 from "./CardFriend.vue?vue&type=style&index=0&id=6fa91248&prod&lang=scss"
import style1 from "./CardFriend.vue?vue&type=style&index=1&id=6fa91248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa91248",
  null
  
)

export default component.exports